var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBMedical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "2 2 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3933_45631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.155 5.76213H10.0585C9.98565 5.76213 9.92659 5.70307 9.92659 5.63021V3.53371C9.92659 3.2986 9.73599 3.10803 9.50091 3.10803H6.52703C6.29192 3.10803 6.10136 3.29863 6.10136 3.53371V5.63021C6.10136 5.70307 6.0423 5.76213 5.96944 5.76213H3.87294C3.63783 5.76213 3.44727 5.95272 3.44727 6.1878V9.16168C3.44727 9.39679 3.63786 9.58735 3.87294 9.58735H5.96944C6.0423 9.58735 6.10136 9.64641 6.10136 9.71927V11.8157C6.10136 12.0509 6.29195 12.2414 6.52703 12.2414H9.50091C9.73602 12.2414 9.92659 12.0508 9.92659 11.8157V9.71927C9.92659 9.64641 9.98565 9.58735 10.0585 9.58735H12.155C12.3901 9.58735 12.5807 9.39676 12.5807 9.16168V6.18783C12.5807 5.95272 12.3901 5.76213 12.155 5.76213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1547 5.76213H10.0582C9.98535 5.76213 9.92629 5.70307 9.92629 5.63021V3.53371C9.92629 3.2986 9.73569 3.10803 9.50061 3.10803H8.01367V12.2414H9.50061C9.73572 12.2414 9.92629 12.0509 9.92629 11.8158V9.7193C9.92629 9.64644 9.98535 9.58738 10.0582 9.58738H12.1547C12.3898 9.58738 12.5804 9.39679 12.5804 9.16171V6.18783C12.5804 5.95272 12.3898 5.76213 12.1547 5.76213Z",
    fill: "#F4F1F1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3933_45631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2,
    height: 15.2,
    fill: "white",
    transform: "translate(0.400391 0.0799561)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMedical);
export default __webpack_public_path__ + "static/media/b-medical.ab5ae7b5bd84f69beca85cbf04927e13.svg";
export { ForwardRef as ReactComponent };